<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisConfirmModal from 'dashboard/components-next/LaisConfirmModal.vue';
import confirmationImage from 'dashboard/assets/images/commission-send-confirmation.svg';

const props = defineProps({
  installment: { type: Object, default: null },
  loading: { type: Boolean, default: false },
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'confirm']);
const { t } = useI18n();
const manager = computed(() => props.installment?.gerente || {});
</script>

<template>
  <LaisConfirmModal
    :show="show"
    :title="t('REAL_ESTATE_COMMISSION_INSTALLMENT.SEND.TITLE')"
    :description="t('REAL_ESTATE_COMMISSION_INSTALLMENT.SEND.DESCRIPTION')"
    :confirm-text="t('REAL_ESTATE_COMMISSION_INSTALLMENT.SEND.CONFIRM')"
    :cancel-text="t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.BACK')"
    confirm-variant="primary"
    icon="i-lucide-send"
    :is-loading="loading"
    @close="emit('close')"
    @confirm="emit('confirm')"
  >
    <template #icon>
      <img
        :src="confirmationImage"
        alt="confirm"
        class="mb-4 max-h-28 w-full rounded-lais object-contain sm:max-h-36"
      />
    </template>
    <div
      class="mt-4 rounded-lais border border-lais-border-soft bg-lais-bg-soft p-4"
    >
      <p class="text-xs font-bold uppercase tracking-wide text-lais-text-muted">
        {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.SEND.RECIPIENT') }}
      </p>
      <p class="mt-2 font-semibold text-lais-text">
        {{
          manager.name ||
          t('REAL_ESTATE_COMMISSION_INSTALLMENT.COMMON.NOT_INFORMED')
        }}
      </p>
      <p class="text-sm text-lais-text-muted">{{ manager.loja_name }}</p>
    </div>
  </LaisConfirmModal>
</template>
